import React from "react";
import { exit_icon } from "../../../icons/exit";
import { useParams } from "react-router-dom";

import { circle_add } from "../../../icons/circle_add";
import { useState } from "react";
import { allowedUsers } from "../../../api";
import { useQuery } from "@tanstack/react-query";
import Client from "../../../utils/client";

const AuctionDetailsModal = ({
  setShowDetails,
  setShowSupervisor,
  setShowBiddings,
  auction,
}) => {
  const auction_id = useParams();
  const { data: allowedUser } = useQuery({
    queryKey: ["states"],
    queryFn: () => allowedUsers(auction_id.id),
    initialData: [],
  });

  const handleJoining = () => {
    setShowDetails(false);
    if (allowedUser.length === 0 || !allowedUser) {
      Client.post("/biddings/join/" + auction_id.id);
      setShowSupervisor(true);
    } else {
      setShowBiddings(true);
    }
  };
  return (
    <>
      <div className=" mt-10 ">
        <div className="flex flex-col lg:w-full   ">
          <div className="text-right  font-bold text-lg mb-6">
            تفاصيل المزاد
          </div>
          <div className="flex flex-col lg:my-3 lg:h-full w-[90%] mx-auto">
            <div
              dir="rtl"
              className="flex flex-col text-right  justify-start mr-4 "
            >
              <p className="text-black font-bold text-lg list-item h-auto mt-0 ">
                مدة المزاد 3 أيام
              </p>
              <p className="text-black font-bold text-lg list-item h-auto mt-0 ">
                بعد خروج الكمية من المخزن فهي تحت مسؤولية المشتري
              </p>
              <p className="text-black font-bold text-lg list-item h-auto mt-0">
                اقل فرق في المزايدات هو 1000 جنيه
              </p>
            </div>
            <div className="my-8 border-2 w-72 mx-auto border-primary py-4 rounded-[15px]  ">
              <div className="w-full flex justify-center ">
                <div className="text-xl text-gray-400 font-bold">
                  مبلغ فتح المزاد
                </div>
              </div>
              <div className="w-full flex flex-col justify-center items-center py-1   ">
                <p className="text-5xl font-bold text-primary">
                  {Number(auction.opening_price).toLocaleString("en-US")}
                </p>
                <p className="text-gray-400 text-lg font-bold">جنية سوداني</p>
              </div>
            </div>

            <div className="flex flex-col w-full  gap-3  items-center lg:items-end px-4 ">
              <div className="lg:mx-0 font-bold text-xl text-primary">
                مشرف المزاد
              </div>

              <div className="flex flex-col gap-2 text-center mb-4 lg:flex-row-reverse justify-between w-[90%]">
                <p className="font-bold ">{auction._supervisor?.name}</p>
                <p className="text-primary font-bold text-lg">
                  <a href={`tel:${auction._supervisor?.phonenumber} `}>
                    {auction._supervisor?.phonenumber}
                  </a>
                </p>
              </div>
            </div>
            <div className="flex flex-col  w-full mt-2  ">
              <div className="h-3" />
              <div className="flex flex-col-reverse justify-center lg:flex-row gap-4 lg:gap-2">
                <div
                  className="w-72 my-3 mb-6 lg:my-0   hover:cursor-pointer lg:w-72 h-[46px] mx-auto lg:mx-0 bg-primary rounded-2xl  text-white font-bold flex justify-center items-center"
                  onClick={handleJoining}
                >
                  {allowedUser?.length === 0 ? (
                    <div>طلب الدخول للمزاد</div>
                  ) : (
                    <div className="flex justify-center gap-2  items-center">
                      مزايدة
                      {circle_add}{" "}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuctionDetailsModal;
